/**
 * Download a file from a fetch Response by extracting the blob and filename
 * from the Content-Disposition header, then triggering a browser download.
 */
export async function downloadResponseAsFile(
  response: Response,
  fallbackFilename: string
): Promise<void> {
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition?.match(/filename="?([^"]+)"?/);
  const filename = match?.[1] || fallbackFilename;

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
